import axios from "axios";
import baseUrl from "../config/baseURL";
import { getAuthToken } from "../services/auth";
import { LeadPatch } from "../pages/EditLeadDetailsPage";
import { Company } from "../utils/types";

export const getCompanies = async (organization_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/companies`; 
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the data:", error);
        return {"success":false, "data": undefined};
    }
};

export const getCompany = async (organization_id: any, company_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/companies/${company_id}/`; 
            const response = await axios.get(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data retrieval failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the data:", error);
        return {"success":false, "data": undefined};
    }
};

export const deleteCompany = async (organization_id: any, company_id: any) => {
    let token = await getAuthToken();
    try {
        if(token){
            let header_token = "Bearer " + token.data;
            const headers = {
                Authorization: header_token,
            };
        try {
            const endpoint = `${baseUrl}/core/organizations/${organization_id}/companies/${company_id}/`; 
            const response = await axios.delete(endpoint,{ headers });
            if (response.status>=200 && response.status <=400) {
            return {"success":true, "data": response?.data};
            } else {
            console.error("Data deletion failed here:", response, response.data);
            return {"success":false, "data": response?.data};
            }
        } catch (error) {
            console.error("An unexpected error occurred:", error);
            return {"success":false, "data": error};
        }
        }else{
        return {"success":false, "data": "error: Token does not exist"};
        }
        
    }catch (error) {
        console.error("Unexpected error occurred while fetching the data:", error);
        return {"success":false, "data": undefined};
    }
};

export const saveCompany = async (
  orgId: string,
  data: Company,
) => {
  const companyData = {
    data,
  };
  console.log('company data', data);
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/companies/`;
    const response = await axios.post(endpoint, data, {headers});

    if (response.status === 201) {
      console.log("Company created successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to create company:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};

export const editCompany = async (
  orgId: string,
  companyId: string,
  data: Company,
) => {
  const companyData = {
    data,
  };
  console.log('company data', data);
  let token = await getAuthToken();
  let headers;

  if(token){
    let header_token = "Bearer " + token.data;
    headers = {
        Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/companies/${companyId}/`;
    const response = await axios.patch(endpoint, data, {headers});

    if (response.status >= 200 && response.status < 300) {
      console.log("Company edited successfully:", response.data);
      return { success: true, data: response.data };
    } else {
      console.error("Failed to update company:", response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error("An unexpected error occurred:", error?.response?.data || error);
    return { success: false, data: error?.response?.data || error };
  }
};
